import Vue from 'vue'

export const EventBus = new Vue()

export const EVENTS = {
	CURRENT_HASH_ON_SCREEN: 'CURRENT_HASH_ON_SCREEN',
	TOGGLE_SIDEBAR_MENU: 'TOGGLE_SIDEBAR_MENU'
}
